import { useRSStore } from '../store/useRSStore'
import { readReleaseListAPI , itemReleaseAPI, addReleaseAPI, updateReleaseAPI, deleteReleaseAPI ,paginationReleaseAPI} from '../api/ReleaseAPI'

import type { release,relfilter,Updaterelease,addrelease } from '../types/types'


export function useRelease() {
  const RSStore = useRSStore()
  const onReadReleaseList = async (relfilter: relfilter) => {
    try {
      const list = await readReleaseListAPI(relfilter)
      RSStore.releaseList = list
    } catch (e) {
      console.error("릴리스 데이터를 가져오는 중 에러 발생:", e)
    }
  }

  const onItemRelease = async (id: number) => {
    try {
      const result = await itemReleaseAPI(id)
      RSStore.releaseItem = result[0]
    } catch (e) {
      console.error("릴리스 조회 중 에러 발생:", e)
    }
  }
  const onAddRelease = async (addrelease: addrelease) => {
    try {
      const result = await addReleaseAPI(addrelease)
      console.log("릴리스 추가 성공, ID:", result)
    } catch (e) {
      console.error("릴리스 추가 중 에러 발생:", e)
    }
  }
  const onUpdateRelease = async (updaterelease: Updaterelease) => {
    try {
      console.log("onUpdateRelease 호출, 데이터:", updaterelease)
      const result = await updateReleaseAPI(updaterelease)
      console.log("릴리스 업데이트 성공, ID:", result)
    } catch (e) {
      console.error("릴리스 업데이트 중 에러 발생:", e)
    }
  }

  const onDeleteRelease = async (id: number) => {
    try {
      const result = await deleteReleaseAPI(id)
      console.log("릴리스 삭제 성공, ID:", result)
    } catch (e) {
      console.error("릴리스 삭제 중 에러 발생:", e)
    }
  }

  const onPaginationRelease = async (relfilter: relfilter) => {
    try {
      const result = await paginationReleaseAPI(relfilter) ?? 0
      return result
    } catch (e) {
      console.error("릴리스 페이지 수 가져오는 중 에러 발생:", e)
    }
  }

  return {
    onReadReleaseList,
    onItemRelease,
    onAddRelease,
    onUpdateRelease,
    onDeleteRelease,
    onPaginationRelease
  }
}